import React, { useState, useEffect } from "react";
import Modal from "react-bootstrap/Modal";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import {
  CreateVehicleCapacityDetails,
  UpdateVehicleCapacityDetails,
  AllVehicleCapacityDetails,
  AllVehicleTypeDetails,
} from "../../Apis/vehicleApi";
import { AllCollectionTypeDetails } from "../../Apis/collectionTypeApi";
import TableComponent from "../../Common/TableComponent/tableComponent";
import Loader from "../../Common/Loader/loader";
import { useNavigate } from "react-router-dom";
import { withTranslation } from "react-i18next";
import * as XLSX from "xlsx"; // Import XLSX library for Excel operations
const ContainerCapacity = ({ t }) => {
  const navigate = useNavigate();
  const headers = [
    "containerTypeName",
    "status",
    "actions",
  ];
  const [lgShow, setLgShow] = useState(false);
  const [vehicleTypeDetails, setVehicleTypeDetails] = useState([]);
  const [collectionTypeDetails, setCollectionTypeDetails] = useState([]);
  const [editVehicleTypeData, setEditVehicleTypeData] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [formSubmitted, setFormSubmitted] = useState(false);
  const [collectionDetails, setCollectionDetails] = useState([]);
  const [formInput, setFormInput] = useState({
    containerTypeName: "",
    isActive: true, // Set isActive to true by default
    vehicleCapacityCode: "",
    vehicleTypeId: ""
  });

  const [vehicleTypes, setVehicleTypes] = useState([]);

  // Fetch all vehicle types
  const fetchAllVehicleTypes = async () => {
    try {
      const response = await AllVehicleTypeDetails();
      setVehicleTypes(response);
    } catch (error) {
      console.error("Error fetching vehicle types:", error);
    }
  };

  useEffect(() => {
    fetchAllVehicleTypes();
  }, []);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    // Sanitize input based on field name
    switch (name) {
      case "vehicleCapacityName":
        // Allow only alphanumeric characters
        const sanitizedValue = value.replace(/[^a-zA-Z0-9\s]/g, "");
        setFormInput((prevData) => ({ ...prevData, [name]: sanitizedValue }));
        break;

      case "vehicleCapacityCode":
        // Allow only alphanumeric characters for the vehicle type code
        const sanitizedCode = value.replace(/[^a-zA-Z0-9-]/g, "").toUpperCase();
        setFormInput((prevData) => ({ ...prevData, [name]: sanitizedCode }));
        break;
      default:
        setFormInput((prevData) => ({ ...prevData, [name]: value }));
        break;
    }
  };

  const handleClose = () => {
    setFormInput({
      vehicleCapacityName: "",
      isActive: "",
      vehicleCapacityCode: "",
    });
    setLgShow(false); // Explicitly set lgShow to false
    setFormSubmitted(false);
  };

  const handleShow = () => {
    setLgShow(true);
    setIsLoading(true);
    setTimeout(() => setIsLoading(false), 1000);
    setFormInput({
      id: "",
      vehicleCapacityName: "",
      vehicleCapacityCode: "",
      isActive: true, // Set isActive to true by default
      vehicleTypeId: ""
    });
    setEditVehicleTypeData(null);
  };

  // Inside handleEditVehicleTypeData function, set collection type name in formInput state
  const handleEditVehicleTypeData = (selectedVehicleCapacity) => {
    setEditVehicleTypeData(selectedVehicleCapacity);
    setIsLoading(true);
    setTimeout(() => setIsLoading(false), 1000);
    setFormInput({
      vehicleTypeId: selectedVehicleCapacity.vehicleTypeId,
      vehicleCapacityCode: selectedVehicleCapacity.vehicleCapacityCode,
      vehicleCapacityName: selectedVehicleCapacity.vehicleCapacityName,
      isActive: selectedVehicleCapacity.isActive,
      vehicleCapacityId: selectedVehicleCapacity.vehicleCapacityId
    });
    setLgShow(true);
  };

  const vehcileTypeData = async () => {
    try {
      setIsLoading(true);
      const response = await AllVehicleCapacityDetails();
      setVehicleTypeDetails(response);
    } catch (error) {
      console.error("Error fetching shift data:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const collectionTypeData = async () => {
    try {
      setIsLoading(true);
      const response = await AllCollectionTypeDetails();
      setCollectionTypeDetails(response);
    } catch (error) {
      console.error("Error fetching shift data:", error);
    } finally {
      setIsLoading(false);
    }
  };
  useEffect(
    () => {
      vehcileTypeData();
      collectionTypeData();
    },
    []
    // [lgShow]
  );

  const handleCreateVehicleTypeDetails = async (e) => {
    e.preventDefault();
    setFormSubmitted(true);
    try {
      setIsLoading(true);
      if (editVehicleTypeData) {
        // Perform validation for required fields only when adding new data
        if (
          !formInput.vehicleCapacityCode ||
          !formInput.vehicleCapacityName ||
          !formInput.vehicleTypeId
        ) {
          // toast.error("Please fill in all required fields.", {
          //   position: "top-right",
          //   autoClose: 5000,
          //   hideProgressBar: false,
          // });
          return;
        }

        // const isDuplicateCode = vehicleTypeDetails.some(
        //   (type) =>
        //     type.vehicleCapacityCode === formInput.vehicleCapacityCode &&
        //     type.vehicleCapacityId !== editVehicleTypeData?.vehicleCapacityId // Exclude the current edited vehicle capacity if any
        // );

        // if (isDuplicateCode) {
        //   // If duplicate code found, show error toast and return
        //   toast.error(
        //     "Vehicle Capacity Code already exists. Please choose a different one.",
        //     {
        //       position: "top-right",
        //       autoClose: 5000,
        //       hideProgressBar: false,
        //     }
        //   );
        //   return;
        // }
      }

      if (editVehicleTypeData) {
        // Update existing vehicle type details
        const updatedVehicleCapacityData = { ...formInput };
        const response = await UpdateVehicleCapacityDetails(
          updatedVehicleCapacityData
        );
        setVehicleTypeDetails([...vehicleTypeDetails, response]);
        toast.success("Vehicle Type Details updated successfully");
        // Fetch all vehicle type details again after update or addition
        fetchAllVehicleTypeDetails();
        handleClose();
      } else {
        // Add new vehicle type details
        const response = await CreateVehicleCapacityDetails(formInput);
        toast.success("Vehicle Type Details created successfully");
      }
      fetchAllVehicleTypeDetails();
      handleClose(); // Close the modal after successfully updating or creating vehicle type details
    } catch (error) {
      if (error.response) {
        const { status, data } = error.response;
        if (status === 400) {
          // Handle 400 status code errors with validation errors
          const validationErrors = data;
          // for (const field in validationErrors) {
          toast.error(validationErrors, {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
          });
          // }
        } else if (status === 409) {
          // Handle 409 status code errors
          const errorMessage = data;
          toast.error(errorMessage, {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
          });
        } else if (status === 404) {
          // Handle 409 status code errors
          const errorMessage = data;
          toast.error(errorMessage, {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
          });
        }
      } else {
        // Handle network errors or other unexpected errors
        toast.error("An error occurred. Please try again later.", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
        });
      }
    } finally {
      setIsLoading(false); // Set loading back to false after API call completes
    }
  };

  // useEffect(() => {
  //   // Update formInput when editDriverData changes
  //   setFormInput(
  //     editVehicleTypeData || {
  //       vehicleCapacityName: "",
  //       isActive:true,
  //       vehicleCapacityCode: "",
  //     }
  //   );
  // }, [editVehicleTypeData]);

  const fetchAllVehicleTypeDetails = async () => {
    try {
      const [vehicleCapacityResponse, vehicleTypeResponse] = await Promise.all([
        AllVehicleCapacityDetails(),
        AllVehicleTypeDetails()
      ]);

      const vehicleTypeMap = new Map(vehicleTypeResponse.map(type => [type.vehicleTypeId, type.vehicleTypeName]));

      const vehicleCapacityData = vehicleCapacityResponse.map(station => {
        return {
          ...station,
          vehicleCapacity: station.vehicleCapacityName,
          status: station.isActive ? "Active" : "InActive",
          vehicleTypeName: vehicleTypeMap.get(station.vehicleTypeId)
        };
      });

      // Sort the data based on the isActive field
      const sortedRouteData = vehicleCapacityData.sort((a, b) => {
        if (a.isActive === b.isActive) {
          return 0;
        }
        return a.isActive ? -1 : 1;
      });

      setCollectionDetails(sortedRouteData);
    } catch (error) {
      console.error("Error fetching vehicle type details:", error);
    }
  };


  useEffect(() => {
    fetchAllVehicleTypeDetails();
  }, []);

  const downloadAsExcel = () => {
    const dataWithSerialNumber = collectionDetails.map((item, index) => ({
      ...item,
      's.no': index + 1,
    }));

    const filteredData = dataWithSerialNumber.map(item => ({
      's.no': item['s.no'],
      vehicleCapacity: item.vehicleCapacity,
      vehicleCapacityCode: item.vehicleCapacityCode,
      vehicleType: item.vehicleTypeName,
      status: item.status,
    }));
    const ws = XLSX.utils.json_to_sheet(filteredData);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "vehicleCapacityData");
    const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    const data = new Blob([excelBuffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8",
    });
    const downloadLink = document.createElement("a");
    downloadLink.href = URL.createObjectURL(data);
    downloadLink.download = "vehicleCapacityData.xlsx";
    downloadLink.click();
  };
  return (
    <>
      <div style={{ width: "100%" }}>
        <div className="content">
          <div className="page-content">
            <div className="page-header">
              <div className="text-end mb-3">
                <button className="button-container" onClick={handleShow}>
                  <i className="fa-solid fa-plus me-1 icon-container"></i>
                  {t("addVehicleCapacity")}
                </button>
              </div>
              <div className="text-end mb-1">
                <button
                  className="btn btn-danger"
                  style={{ backgroundColor: "#EC1117" }}
                  onClick={downloadAsExcel}
                >
                  Download Excel
                </button>
              </div>
            </div>

            <div className="card">
              <div className="card-body">
                <div className="top-header">
                  <span>{t("Vehicle Capacity Details")}</span>
                </div>
                <TableComponent
                  DataFetchURL={collectionDetails}
                  headers={headers}
                  filterFunction={(data) =>
                    data.filter(
                      (item) => item.status === 1 || item.status === 2
                    )
                  }
                  editData={handleEditVehicleTypeData} // Pass the callback function
                  editDataDetails={editVehicleTypeData}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      {isLoading && <Loader />}
      <Modal
        size="lg"
        show={lgShow}
        onHide={() => setLgShow(false)}
        aria-labelledby="example-modal-sizes-title-lg"
        backdrop="static"
      >
        <Modal.Header>
          <Modal.Title id="example-modal-sizes-title-lg">
            {editVehicleTypeData
              ? t("editVehicleCapacity")
              : t("addVehicleCapacity")}
          </Modal.Title>
          <i
            class="fa-solid fa-xmark close-container"
            onClick={handleClose}
          ></i>
        </Modal.Header>
        <hr />
        <Modal.Body>
          <form onSubmit={handleCreateVehicleTypeDetails}>
            <div className="row">
              <div className="col-md-4 mb-3">
                <div className="form-group">
                  <label className="form-label">
                    {t("Vehicle Type")}
                    <span style={{ color: "#EC1117" }}> *</span>
                  </label>


                  <select
                    id="vehicleType"
                    name="vehicleTypeId"
                    value={formInput.vehicleTypeId}
                    onChange={handleInputChange}
                    className={`form-select ${formInput.vehicleTypeId || !formSubmitted
                      ? ""
                      : "input-error"
                      }`}
                  >
                    <option value="">Select Vehicle Type</option>
                    {vehicleTypes.map((vehicleType) => (
                      <option key={vehicleType.vehicleTypeId} value={vehicleType.vehicleTypeId}>
                        {vehicleType.vehicleTypeName}
                      </option>
                    ))}
                  </select>
                  {!formInput.vehicleTypeId && formSubmitted && (
                    <div className="required-message">
                      {" "}
                      Vehicle Type Name is Required
                    </div>
                  )}
                </div>
              </div>
              <div className="col-md-4 mb-3">
                <div className="form-group">
                  <label className="form-label">
                    {t("Vehicle Capacity Code")}
                    <span style={{ color: "#EC1117" }}> *</span>
                  </label>
                  <input
                    type="text"
                    name="vehicleCapacityCode"
                    className={`form-control ${formInput.vehicleCapacityCode || !formSubmitted
                      ? ""
                      : "input-error"
                      }`}
                    placeholder="Enter VehicleCapacity Code"
                    onChange={handleInputChange}
                    value={formInput.vehicleCapacityCode}
                    maxLength={8}
                  />
                  {!formInput.vehicleCapacityCode && formSubmitted && (
                    <div className="required-message">
                      {" "}
                      Vehicle Code is Required
                    </div>
                  )}
                </div>
              </div>
              <div className="col-md-4 mb-3">
                <div className="form-group">
                  <label className="form-label">
                    {t("Vehicle Capacity Name")}
                    <span style={{ color: "#EC1117" }}> *</span>
                  </label>
                  <input
                    type="text"
                    name="vehicleCapacityName"
                    className={`form-control ${formInput.vehicleCapacityName || !formSubmitted
                      ? ""
                      : "input-error"
                      }`}
                    placeholder="Enter VehicleCapacity Name"
                    onChange={handleInputChange}
                    value={formInput.vehicleCapacityName}
                  />
                  {!formInput.vehicleCapacityName && formSubmitted && (
                    <div className="required-message">
                      {" "}
                      Vehicle Name is Required
                    </div>
                  )}
                </div>
              </div>

              <div className="col-md-4" style={{ marginTop: "5px" }}>
                <label className="form-label">
                  {t("status")}
                  <span style={{ color: "#EC1117" }}> *</span>
                </label>
                <div className="form-group" style={{ display: "flex" }}>
                  <div className="form-check">
                    <input
                      type="radio"
                      className="form-check-input"
                      name="isActive"
                      id="activeRadio"
                      checked={formInput.isActive} // Set checked attribute to the value of formInput.isActive
                      onChange={() =>
                        handleInputChange({
                          target: { name: "isActive", value: true },
                        })
                      }
                    />

                    <label className="form-check-label" htmlFor="activeRadio">
                      Active
                    </label>
                  </div>
                  <div className="form-check" style={{ marginLeft: "40px" }}>
                    <input
                      type="radio"
                      className="form-check-input"
                      name="isActive"
                      id="inactiveRadio"
                      checked={formInput.isActive === false}
                      onChange={() =>
                        handleInputChange({
                          target: { name: "isActive", value: false }, // Set value to false
                        })
                      }
                    />

                    <label className="form-check-label" htmlFor="inactiveRadio">
                      InActive
                    </label>
                  </div>
                </div>
              </div>
            </div>
            <div className="modal-footer d-flex justify-content-center">
              <button type="submit" className="deployment-button">
                <i class="fa-solid fa-check done-container"></i>
                {editVehicleTypeData ? t("Update") : t("Save")}
              </button>
            </div>
          </form>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default withTranslation()(ContainerCapacity);
